import { useEffect, useState } from "react";
import { useMap } from "../App";

export function useMapView() {
  const map = useMap()!;
  const [view, setView] = useState<ol.View>(map.getView());
  useEffect(() => {
    const key = map.on("change:view", () => setView(map.getView()));
    return () => ol.Observable.unByKey(key);
  }, [map]);
  return view;
}
export function useMapProjection() {
  const view = useMapView();
  const [projection, setProjection] = useState<ol.proj.Projection>(view.getProjection());
  useEffect(() => {
    const key = view.on("change", () => setProjection(view.getProjection()));
    return () => ol.Observable.unByKey(key);
  }, [view]);
  return projection;
}
